module.exports = __webpack_public_path__ + "img/sunrise.0d500040.svg";